import React, { useContext, useEffect, useState } from "react";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import AssetSite from "./AssetSite";
import { CustomModalStyles } from "../../../../../../styles/CustomModalStyles";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetSubsidiarySites } from "../queries/queries";
import {
  AtsSubsidiarySiteEdge,
  AtsSubsidiarySiteOrderField,
  DeleteSubsidiarySiteResult,
  DeleteSubsidiarySiteVar,
  GetSubsidiarySitesResult,
  GetSubsidiarySitesVar,
  SiteQueryType,
} from "../queries/types";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../../utils/constants";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../../utils/types";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../../styles/Variables";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../../../utils/UtilFunctions";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import Edit from "../../../../../../images/EditProfile.svg";
import View from "../../../../../../images/View Ticket.svg";
import Delete from "../../../../../../images/Delete.svg";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import { Step, StepLabel, Stepper } from "@mui/material";
import { Title } from "../../../../../../stories/Title/Title";
import DeleteModal from "../../../../../../customComponents/DeleteModal";
import { DeleteSubsidiarySite } from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import Close from "../../../../../../images/Close.svg";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../../../../pages/LoadingModal";
import MessageModal from "../../../../../../customComponents/MessageModal";
import Navbar from "../../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../../utils/Enum.keys";
import ImportSite from "./ImportSubsidiarySite";
import useLabels from "../../../../../../customHooks/useLabels";
import useCompanyConfiguration from "../../../../../../customHooks/useCompanyConfiguration";
import Input from "../../../../../../stories/Input/Input";

export interface Props {
  operation: Operation;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface CustomModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  contentComponent: React.ReactNode;
}

const AssetSiteList = ({ operation, setModalFlag }: Props) => {
  const { companyLabel, itemLabel, subsidiaryLabel, subsidiarySiteLabel } =
    useLabels();

  const subsidaryStepHeader = () => {
    return [
      `${subsidiaryLabel} Details`,
      `${itemLabel} Site or Location Points`,

      // "User Details"
    ];
  };
  const [addModal, setAddModal] = useState<boolean>(false);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [subsidiriesSite, setSubsidiriesSite] = useState<
    AtsSubsidiarySiteEdge[]
  >([]);
  const [editModal, setEditModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [message, setMessage] = useState(emptyMessage);
  const [importModal, setImportModal] = useState(false);
  const [searchData, setSearchData] = useState("");

  const { customer_id, sub_id, company_id } = useUrlParams();
  const { Masters_Table } = useAssetTableJson();
  const { state, dispatch } = useContext(AppContext);
  const { user_details } = useLoggedInUserDetails();
  const stepsHeader = subsidaryStepHeader();

  const navigate = useNavigate();
  const { USE_ENABLE_JUNCTION } = useCompanyConfiguration();

  const [getSubsidiarySites, { data, loading, fetchMore }] = useLazyQuery<
    GetSubsidiarySitesResult,
    GetSubsidiarySitesVar
  >(GetSubsidiarySites);

  const [
    deleteSubsidiarySite,
    { data: deletdData, loading: DeleteSubsidiarySiteLoading },
  ] = useMutation<DeleteSubsidiarySiteResult, DeleteSubsidiarySiteVar>(
    DeleteSubsidiarySite,
    {
      onError: (e) => {
        setMessage({
          message: e.message,
          flag: true,
          operation: Operation.NONE,
        });
      },
    }
  );

  useEffect(() => {
    getSubsidiarySites({
      variables: {
        after: null,
        customerID: customer_id ? customer_id : 0,
        companyID: company_id ? company_id : 0,
        first: ROWS_PER_PAGE,
        empID: user_details.id,
        orderBy: {
          direction: OrderDirection.ASC,
          field: AtsSubsidiarySiteOrderField.CREATED_AT,
        },
        name: searchData,
        subsidiaryID: sub_id
          ? sub_id
          : state.subsidiaryId
          ? state.subsidiaryId
          : 0,
      },
    });
  }, [
    getSubsidiarySites,
    customer_id,
    company_id,
    sub_id,
    user_details.id,
    state.subsidiaryId,
    searchData,
  ]);

  const dynamicHeaders: TableHeaderProps[] = Masters_Table.Subsidary.map(
    (header) => ({
      headerName: header.headerName,
      cellClassName: header.cellClassName as string,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex as number,
      hideable: header.hideable,
    })
  );
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      cellClassName: "td-status ",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={View}
              alt=""
              onClick={() => {
                navigate(
                  `/${customer_id}/company/${company_id}/subsidiary/${sub_id}/site/${params.row.siteId}/assetsummary/0`
                );
              }}
            />
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_SUB_SITE_ID,
                  payload: {
                    subSiteId: params.row.siteId,
                  },
                });
                setEditModal(true);
                // setAddModal({
                //   flag: true,
                //   operation: Operation.UPDATE,
                // });
              }}
            />
            <img
              src={Delete}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_SUB_SITE_ID,
                  payload: {
                    subSiteId: params.row.siteId,
                  },
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSubsidiarySites.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = subsidiriesSite.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSubsidiriesSite(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            company_name: node.name,
            company_addr: node.address,
            company_email: node.email,
            company_mobile: node.mobile,
            company_c_person: node.contactPerson,
            subId: node.subsidiaryID,
            siteId: node.id,
            companyID: node.companyID,
            customerID: node.customerID,
          }))
        );
      } else {
        setSubsidiriesSite(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            company_name: node.name,
            company_addr: node.address,
            company_email: node.email,
            company_mobile: node.mobile,
            company_c_person: node.contactPerson,
            subId: node.subsidiaryID,
            siteId: node.id,
            companyID: node.companyID,
            customerID: node.customerID,
          }))
        );
      }
      setEndCursor(data.GetSubsidiarySites.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSubsidiarySites.edges;
              const pageInfo = fetchMoreResult.GetSubsidiarySites.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSubsidiarySites.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSubsidiarySites: {
                  edges: [...subsidiriesSite, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSubsidiarySites.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length) {
      scrollTable.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  const HandleDelete = async () => {
    try {
      setDeleteModal(false);
      if (state.subSiteId) {
        await deleteSubsidiarySite({
          variables: {
            user_details,
            subsidiarySiteID: state.subSiteId,
          },
          refetchQueries: [
            {
              query: GetSubsidiarySites,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id,
                subsidiaryID: sub_id
                  ? sub_id
                  : state.subsidiaryId
                  ? state.subsidiaryId
                  : 0,
                empID: user_details.id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiarySiteOrderField.CREATED_AT,
                },
                name: EMPTY_STRING,
                input: {
                  ldgrID: 0,
                  queryType: SiteQueryType.ALL,
                },
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.DeleteSubsidiarySiteResult) {
            setMessage({
              flag: true,
              message: "Deleted Successfully",
              operation: Operation.DELETE,
            });
          }
        });
      }
    } catch (error) {}
  };

  //hot key for addition ctrl+a
  useHotKey({
    handleFunc: () => {
      if (state.empSubType === empType.SYS_ADMIN) {
        setAddModal(!addModal);
      }
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>{subsidiarySiteLabel}</Title>

      <div className="subsidarysite__asset">
        <div className="subsidarysite__asset--select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          <div className="col flex-end">
            {state.empSubType === empType.SYS_ADMIN ? (
              <Button mode="addnew" onClick={() => setAddModal(true)} />
            ) : null}
          </div>
        </div>
        <div className="subsidarysite__tableblock">
          <StyledDatagrid
            columns={
              state.empSubType === empType.SYS_ADMIN ? columns : dynamicHeaders
            }
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={async (params) => {
              if (params.field === "company_name" && USE_ENABLE_JUNCTION) {
                navigate(
                  `/${params.row.customerID}/company/${params.row.companyID}/subsidiary/${params.row.subId}/site/${params.row.siteId}/junctions`
                );
              }
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <div className="row">
          <div className="col-10">
            {state.empSubType === empType.SYS_ADMIN ? (
              <Button
                mode="excel"
                type="button"
                onClick={() => {
                  setImportModal(!importModal);
                }}
              >
                Import {subsidiarySiteLabel}
              </Button>
            ) : null}

            <Button
              mode="back"
              onClick={() => {
                if (operation === Operation.VIEW) setModalFlag(false);
                else navigate(-1);
              }}
            />
          </div>
          <div className="col flex-end">
            <div className="overall-total-count">
              Total Count : <b>{data?.GetSubsidiarySites.totalCount}</b>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={
          <AssetSite setModalFlag={setAddModal} operation={Operation.CREATE} />
        }
        style={CustomModalStyles}
      />
      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={
          <AssetSite setModalFlag={setEditModal} operation={Operation.UPDATE} />
        }
        style={CustomModalStyles}
      />
      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={
          <ImportSite
            setModalFlag={setImportModal}
            NavType={LicenseTypes.COMPANY}
            pageType={PageFor.MODAL}
          />
        }
        style={CustomModalStyles}
      />

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <DeleteModal
        id={0}
        setModalFlag={setDeleteModal}
        modalFlag={deleteModal}
        handleDelete={HandleDelete}
      />
      <LoadingModal flag={(!searchData && loading) || DeleteSubsidiarySiteLoading} />
    </>
  );
};

export default AssetSiteList;
